export default __webpack_public_path__ + "static/media/level3.a8dd0f24.png";